<template>
    <tab-layout :buttons="buttons" :permissions="permissions" @openCustomfields="openCustomfields">
        <template #title>
            {{ $l10n.__('Champs personnalisés') }}
        </template>

        <template #content>
            <div v-if="loading" class="prelative mt-3">
                <preloader :display="loading"/>
            </div>
            <div v-if="!loading" class="flex-column overflow-initial">
                <div v-if="customFields.length > 0">
                    <customfields
                        :cfs="customFields"
                        :cfv="customFieldValues"
                        :emitEditSuccess="emitEditSuccess"
                        mode="readtable"/>
                </div>
                <div v-else>
                    <div v-if="!loading" class="placeholder">
                        <p>{{ $l10n.__("Aucun champ personnalisé défini") }}</p>
                    </div>
                </div>

            </div>
        </template>
    </tab-layout>
</template>

<script>
import Customfields from '../../forms/Customfields.vue'
import OverviewTabMixin from './OverviewTabMixin'
import { buildUrl } from '../../../helpers'
import CfFormMixins from '../../../mixins/CfFormMixins'
import Preloader from "vcomponents/utilities/Preloader.vue";
import TabLayout from 'vcomponents/overview/tabs/TabLayout.vue';

import { createNamespacedHelpers } from 'vuex'
const popupPanelMapActions  = createNamespacedHelpers('popupPanel').mapActions;

export default {
    mixins: [OverviewTabMixin, CfFormMixins],
    props: {
        more: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            permissions: {},
            loading: true,
            emitEditSuccess: 'form:customfields:edit:success'
        }
    },
    computed: {
        buttons(){
            return this.more.buttons.map(button => {
                button.linkedid = this.$store.getters.linkedid
                button.linkedtype = this.$store.getters.linkedtype
                button.params.route = this.route
                button.params.emitEditSuccess = this.emitEditSuccess
                return button
            })
        },
        parameters() {
            return [
                {
                    key: 'linkedid',
                    value: this.$store.getters.linkedid
                }
            ]
        },
        route(){
            return buildUrl(this.more.url, this.parameters)
        }
    },
    created(){
        this.fetch()
    },
    methods: {
        ...popupPanelMapActions([
            'open',
        ]),
        fetch() {
            this.loading = true
            this.$ajax.get(this.route, {}, (response) => {
                this.customFields    = response.customFields;
                this.customFieldValues    = response.customFieldValues;
                this.permissions = response.permissions
                this.loading = false
            })
        },
        openCustomfields(payload){
            if(!payload.disabled){
                this.open({
                    key: "customfieldForm",
                    props: {
                        linkedid: payload.params.linkedid,
                        linkedtype: payload.params.linkedtype,
                        emitEditSuccess: this.emitEditSuccess,
                        route: this.route
                    }
                })
            }
        },
    },
    components: {
        Preloader,
        TabLayout,
        Customfields
    }
}
</script>

<style scoped>
    .overflow-initial {
        overflow-y: initial;
    }
</style>
